module.exports = __webpack_public_path__ + "img/9788950981501.85510f14.jpg";